// extracted by mini-css-extract-plugin
export var addToCartWrapper = "_ol-8";
export var editMode = "_ol-3";
export var headerRow = "_ol-a";
export var headerTitle = "_ol-b";
export var product = "_ol-1";
export var productDetails = "_ol-5";
export var productDivider = "_ol-7";
export var productImage = "_ol-2";
export var productInfo = "_ol-4";
export var productTitle = "_ol-6";
export var strikethrough = "_ol-9";
export var upsellProductsCard = "_ol-0";